<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Editar Chofer
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="apellido"
                prepend-icon="mdi-account"
                label="Apellidos *"
                maxlength="50"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="nombre"
                prepend-icon="mdi-account"
                label="Nombres *"
                maxlength="50"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarChofer"
            >Guardar</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../axios-auth.js";

export default {
  data: (vm) => ({
    nombre: null,
    apellido: null,
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
  }),

  props: ["visible", "idChofer"],

  computed: {
    show: {
      get() {
        if (this.visible) this.buscarDatosChofer();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    buscarDatosChofer() {
      let self = this;

      axios
        .get("/Traslados/BuscarDatosChofer?", {
          params: {
            idChofer: this.idChofer,
          },
        })
        .then((response) => {
          self.nombre = response.data.nombreChofer;
          self.apellido = response.data.apellidoChofer;
        })
        .catch((error) => {});
    },
    modificarChofer() {
      this.$swal({
        title: "Modificar Chofer",
        text: "¿Desea modificar el chofer?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosChofer = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            nombreChofer: this.nombre,
            apellidoChofer: this.apellido,
            idChofer: this.idChofer,
          };
          let self = this;
          axios
            .post("/Traslados/ModificarChofer", datosChofer)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title: "Ya existe un chofer registrado con ese nombre",
                  vm: self,
                });
              } else {
                self.$refs.form.resetValidation();

                document.getElementsByClassName(
                  "v-dialog--active"
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Chofer modificado exitosamente",
                  vm: self,
                });
                self.$emit("choferModificado");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El chofer no pudo ser modificado",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
